import StockTools from '../../../editor/core/highed.stocktools';
import { removeTextFields, keyifyNestedObject, getObjectValueByString } from '../../../editor/core/highcharts-editor';
import { snackBar, merge, setAttr } from 'highed';
import defaultThemes from '../../../shared/editor/DefaultThemes';
import { isArray } from 'lodash';
import {
  postTeamTableUsingTeamid,
  postTeamTableUsingTeamidAndTableid,
  postTeamTableEmbedUsingTeamidAndTableid,
  getTeamTableWithTeamidAndTableid,
  getTeamThemeWithTeamidAndThemeid,
} from '../../../api/cloudApiGenerated';

export const getThemeDetails = (teamId, themeId) =>
  new Promise((resolve, reject) => {
    const isDefaultTheme = defaultThemes.filter((element) => element.id === themeId);
    if (isDefaultTheme.length > 0) {
      return resolve({
        id: isDefaultTheme[0].id,
        name: isDefaultTheme[0].name,
        options: isDefaultTheme[0].template,
        customCode: isDefaultTheme[0].customCode.join(''),
      });
    } else {
      return getTeamThemeWithTeamidAndThemeid(teamId, themeId).then((actualTheme) => {
        let unpacked = JSON.parse(actualTheme.data);

        if (unpacked.template && Array.isArray(unpacked.template)) {
          unpacked.templateOptions = {}; // Could cause problems for other charts but should really be done this way

          unpacked.template.forEach((template) => {
            unpacked.templateOptions = merge(unpacked.templateOptions, template || {});
          });

          unpacked.options = merge(unpacked.templateOptions, unpacked.options);
        } else unpacked.options = merge(unpacked.options, unpacked.template || {}); //Legacy

        let stockConstr = false;

        if (unpacked && unpacked.settings && unpacked.settings.constructor && isArray(unpacked.settings.constructor)) {
          if (
            unpacked.settings.constructor.some(function (a) {
              return a === 'StockChart';
            })
          ) {
            stockConstr = true;
          }
        }

        if (unpacked.theme && unpacked.theme.options && unpacked.theme.isevervizTheme) {
          unpacked.options = merge(merge({}, unpacked.theme.options), unpacked.options);
        }

        return resolve({
          id: actualTheme.chart_id,
          name: actualTheme.name,
          options: unpacked.options,
          customCode: unpacked.customCode,
          plugins: unpacked.settings ? unpacked.settings.plugins : null,
          stockConstr,
        });
      });
    }
  });
